import BigUserIcon from "./BigUserIcon";
import EditPenIcon from "./EditPenIcon";
import SettingIcon from "./SettingIcon";
import MyBookingIcon from "./MyBookingIcon";
import HelpIcon from "./HelpIcon";
import PreviewEyeIcon from "./PreviewEyeIcon";
import UploadIcon from "./UploadIcon";
import Replay from "./Replay";
import LogoutIcon from "./LogoutIcon";
import DeleteIcon from "./DeleteIcon";
const SettingsIcons = {
  BigUserIcon,
  EditPenIcon,
  DeleteIcon,
  SettingIcon,
  MyBookingIcon,
  HelpIcon,
  PreviewEyeIcon,
  UploadIcon,
  Replay,
  LogoutIcon,
};

export default SettingsIcons;
